<script>
  import Empty from '../general/empty.svelte'
  import { cn } from '@lib/utils'
  
  let { children, empty = false, emptyMessage, emptyClass } = $props()

  let loading = $state(false)
</script> 

{#if empty}
  <Empty message={emptyMessage} class={emptyClass} />
{:else}
  <div class={cn("border border-gray-200/80 rounded-lg bg-white overflow-x-auto", loading ? "opacity-50" : "")}>
    <table class="w-full min-w-[640px] table-fixed text-left border-separate border-spacing-0">
      {@render children?.()}
    </table>
  </div>
{/if}